<template>
  <v-layout justify-center>
    <v-dialog width="1200px" v-model="dialog" v-closable="{ exclude: [], handler: 'onClickOutside' }" @keydown.esc="handleExternalClose" persistent max-width="800">
      <template v-slot:activator="{ on }" v-if="addBtn">
        <v-btn color="#0e9e98de" dark small absolute top right fab v-on="on">
          <v-icon>add</v-icon>
        </v-btn>
      </template>

      <bank-account-form 
        ref="bankAccountForm"
        :inDialog="true"
        :mode="mode"
        :record="record"
        :errors="errors"
        :admin="admin"
        :show_partner_external_bank_accounts="show_partner_external_bank_accounts"
        :show_external_bank_accounts="show_external_bank_accounts"
        :subject_document_type="subject_document_type"
        :partner="partner"
        @createBankAccount="createBankAccount"
        @updateBankAccount="updateBankAccount"
        @cancel="onCancel"
      />
    </v-dialog>
  </v-layout>
</template>

<script>
import BankAccountsForm from "./BankAccountsForm"

export default {
  name: 'BankAccountsDialog',
  components: { 'bank-account-form': BankAccountsForm },
  props: {
    addBtn: {
      type: Boolean,
      default: true
    },
    mode: {
      type: String
    },
    record: {
      type: Object
    },
    errors: {
      type: Object
    },
    admin: {
      type: Boolean,
      default: false
    },    
    dialog: {
      type: Boolean,
      default: false
    },
    show_partner_external_bank_accounts: {
      type: Boolean,
      default: false
    },
    show_external_bank_accounts: {
      type: Boolean,
      default: false
    },
    subject_document_type: {
      type: String
    },
    partner: {
      type: Boolean,
      default: false
    }
  },
  data(vm) {
    return {
      opening: false
    }
  },
  watch: {
    dialog (val) {
      if (val == false) {
        // closed
      } else {
        // opened
        this.opening = true
        setTimeout(function(){
          this.$nextTick(function () {
            this.opening = false
          })
        }.bind(this), 500)
      }
    },
  },
  methods: {
    createBankAccount(e) {
      this.$emit('createBankAccount')
    },
    updateBankAccount(e) {
      this.$emit('updateBankAccount')
    },
    onClickOutside() {
      if (!this.isMobile && this.dialog === true && !this.opening) {
        this.handleExternalClose()
      }
    },
    onCancel() {
      this.handleExternalClose()
    },
    handleExternalClose() {
      if (this.$refs.bankAccountForm && this.$refs.bankAccountForm.resetFormState) {
        this.$refs.bankAccountForm.resetFormState()
      }
      this.$emit('closeDialog')
    }
  },
  computed: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
  .align-btn-toogle {
    padding-top: 20px!important;
    width: 100%!important;
    position: absolute!important;
    top: 40px;
    left: 0px;
    box-shadow: none!important;
  }
  
  .adjust-btn-width {
    width: 50%!important;
  }
  .account-type {
    display: flex;
    align-items: baseline;
    justify-content: left;
    flex-wrap: wrap;
  }
</style>




// WEBPACK FOOTER //
// src/BankAccountsDialog.vue